/* eslint-disable no-console */

import {
	unregister
} from 'register-service-worker';

unregister(`${process.env.BASE_URL}service-worker.js`);